export default defineI18nConfig(() => ({
  legacy: false,
  locale: "fr",
  fallbackLocale: "fr",
}));
